import "./../estadisticas.scss";
import React, { useEffect, useRef, useState } from "react";
import ConstantesTabla from "../../../../utils/ConstantesTabla";
import DataTablePaginacionExterna from "../../../atoms/datatable/DataTablePaginacionExterna";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import { getBusquedaUsuarios} from "../../../services/EstadisticasService";

const BusquedaUsuarioAcceso = ({ setZona }) => {

  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [formBus, setFormBus] = useState({
    dni:null,
    nombre:null,
    apellido1:null,
    apellido2:null
  })
  const [data, setData] = useState();
  const [totalPages, setTotalPages] = useState(0);

  const handleInput = (e,name,setData) =>{
    
    setData((prevState) => ({
      ...prevState,
      [name]:e.target.value
    }))
    
  }

  const handleEnvioBusqueda = (valores,currentPage,pageSize) =>{
    
    setCurrentPage(0)
    setLoading(true)
    getBusquedaUsuarios(valores,currentPage,pageSize).then((data) =>{
      setData(data);
      
      setLoading(false)
      setTotalPages(data.totalPages);
    })
  }

  const formBusRef = useRef(formBus);

  useEffect(() => {
    
    setLoading(true);
    getBusquedaUsuarios(formBusRef.current, currentPage, pageSize).then((data) => {
      
      
      setData(data);
      setTotalPages(data.totalPages);
      setLoading(false);
    });
  }, [currentPage, pageSize]);


  return (
    <>

      <div className="container containerUsuariosConectados">
      {/*<TituloCard clases={"mb-3 mt-2 d-flex justify-content-center "} tipo="tituloModal" titulo={"Búsqueda de un Usuario que ha accedido a la Web"} />*/}
      <h3 className="tituloPaginaAdmin">Búsqueda de un Usuario que ha accedido a la Web</h3>  
        <div className="formBusqueda mb-5">
          <div className="row d-flex justify-content-center mb-2">
            <div className="col-4 row align-items-center">
              <label htmlFor="dniAcceso" className="col-4">DNI:</label>
              <div className="col-8">
                <input type="text" id="dniAcceso" className="form-control" onChange={(e) => handleInput(e,"dni",setFormBus)}/>
              </div>
            </div>
            <div className="col-4 row align-items-center">
              <label htmlFor="nombreAcceso" className="col-4">Nombre:</label>
              <div className="col-8">
                <input type="text" id="nombreAcceso" className="form-control" onChange={(e) => handleInput(e,"nombre",setFormBus)}/>
              </div>
            </div>

          </div>
          <div className="row d-flex justify-content-center">
          <div className="col-4 row align-items-center">
              <label htmlFor="ape1Acceso" className="col-4">Apellido 1:</label>
              <div className="col-8">
                <input type="text" id="ape1Acceso" className="form-control" onChange={(e) => handleInput(e,"apellido1",setFormBus)}/>
              </div>
            </div>
            <div className="col-4 row align-items-center">
              <label htmlFor="ape2Acceso" className="col-4">Apellido 2:</label>
              <div className="col-8">
                <input type="text" id="ape2Acceso" className="form-control" onChange={(e) => handleInput(e,"apellido2",setFormBus)}/>
              </div>
            </div>
          </div>
          <div className="row mt-4 justify-content-end">
            <div className="col-3 ">
              <button
                className={`btn rounded p-1`}
                type="button"
                onClick={() => handleEnvioBusqueda(formBus,currentPage,pageSize)}
              >
                Buscar
              </button></div>
          </div>
        </div>
        {}
        {data?.content?.length !== 0 && data !== null && data !== undefined ? (<>
          {loading ? (<div className=""><SpinnerCircle /></div>) : (<>
            <DataTablePaginacionExterna
              data={data}
              columnas={[
                ...ConstantesTabla.columnasBusquedaAccesos,
              ]}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              totalPages={totalPages}
            />
            <div className="my-2 row d-flex justify-content-center">
              <div className="col-3">
                <button
                  className={`btnRed rounded p-1`}
                  type="button"
                  onClick={() => { setZona({ "links": true }) }}
                >
                  Volver
                </button>
              </div>
            </div>
          </>)}
        </>) : (<>
          <div className="text-center">
            <span className="">No hay usuarios con los criterios indicados.</span>
            <div className="my-2 row d-flex justify-content-center">
              <div className="col-3">
                <button
                  className={`btnRed rounded p-1`}
                  type="button"
                  onClick={() => { setZona({ "links": true }) }}
                >
                  <i className="fa-solid fa-rotate-left"></i>{" "}
                  Volver
                </button>
              </div>
            </div>
          </div>
        </>)}





      </div >


    </>

  );
};
export default BusquedaUsuarioAcceso;
